import { useCallback, useRef } from "react";

// Synchronous double-submit guard for a mutating action. The atom-driven
// `disabled` only lands on the next render, so two activations in one tick
// would otherwise send two requests (two fee charges; a cancel followed by a
// refused second cancel whose error toast reads as failure). Returns a runner:
// a submit started while another is still in flight is dropped. A failed
// submit releases the guard and its rejection passes through to the caller.
export const useSubmitGuard = () => {
    const inFlightRef = useRef(false);

    return useCallback(async (submit: () => Promise<void>): Promise<void> => {
        if (inFlightRef.current) {
            return;
        }
        inFlightRef.current = true;
        try {
            await submit();
        } finally {
            inFlightRef.current = false;
        }
    }, []);
};
